import useScrollAnimation from '../../../hooks/useScrollAnimation';
import { restaurantInfo } from '../../../mocks/restaurant';

const AccessSection = () => {
  const { ref: titleRef, animStyle: titleAnim } = useScrollAnimation();
  const { ref: infoRef, animStyle: infoAnim } = useScrollAnimation();
  const { ref: mapRef, animStyle: mapAnim } = useScrollAnimation();

  const infoRows = [
    {
      icon: 'ri-store-2-line',
      label: '店名',
      value: restaurantInfo.name,
    },
    {
      icon: 'ri-map-pin-line',
      label: '住所',
      value: restaurantInfo.address,
    },
    {
      icon: 'ri-phone-line',
      label: '電話番号',
      value: restaurantInfo.phone,
    },
    {
      icon: 'ri-sun-line',
      label: 'ランチ',
      value: restaurantInfo.lunchHours,
    },
    {
      icon: 'ri-moon-line',
      label: 'ディナー',
      value: restaurantInfo.dinnerHours,
    },
    {
      icon: 'ri-calendar-close-line',
      label: '定休日',
      value: restaurantInfo.closedDay,
    },
    {
      icon: 'ri-armchair-line',
      label: '座席数',
      value: restaurantInfo.seats,
    },
    {
      icon: 'ri-car-line',
      label: '駐車場',
      value: restaurantInfo.parking,
    },
    {
      icon: 'ri-bank-card-line',
      label: 'お支払い',
      value: restaurantInfo.payment,
    },
  ];

  return (
    <section id="access" className="bg-cream-light py-20 md:py-28 px-5 md:px-10">
      <div className="max-w-6xl mx-auto">
        {/* Title */}
        <div ref={titleRef} style={titleAnim} className="text-center mb-14">
          <p className="font-sans-jp text-xs tracking-[0.3em] text-teal-deep mb-3 uppercase">
            Access
          </p>
          <h2 className="font-serif-jp font-bold text-brown-dark text-2xl md:text-3xl tracking-wide mb-4">
            店舗案内・アクセス
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4">
            <div className="h-px w-10 bg-teal-deep/30" />
            <div className="w-1.5 h-1.5 rounded-full bg-orange-sunset" />
            <div className="h-px w-10 bg-teal-deep/30" />
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-10 md:gap-14 items-start">
          {/* Info Table */}
          <div ref={infoRef} style={infoAnim} className="w-full md:w-2/5">
            <div className="bg-white rounded-lg border border-brown-dark/8 overflow-hidden">
              {infoRows.map((row, i) => (
                <div
                  key={row.label}
                  className={`flex items-start gap-4 px-5 py-4 ${i !== infoRows.length - 1 ? 'border-b border-brown-dark/8' : ''}`}
                >
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className={`${row.icon} text-teal-deep text-base`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-sans-jp text-xs text-brown-light tracking-wider mb-0.5">
                      {row.label}
                    </p>
                    <p className="font-sans-jp text-sm text-brown-dark leading-snug">
                      {row.value}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <p className="font-sans-jp text-xs text-brown-light mt-4 leading-loose px-1">
              ※ 営業時間・定休日は変更になる場合があります。詳細はお電話にてご確認ください。
            </p>
          </div>

          {/* Google Maps */}
          <div ref={mapRef} style={mapAnim} className="w-full md:w-3/5">
            <div className="w-full h-64 md:h-96 rounded-lg overflow-hidden border border-brown-dark/10" style={{ borderRadius: '4px' }}>
              <iframe
                title="ASIAN KITCHEN BALEN アクセスマップ"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d25874.505734530!2d136.95000!3d35.24800!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6003ab4c86543521%3A0x6b8dbc78a66e0261!2z5pKp5pel5biC%E3%80%81%E6%84%9B%E7%9F%A5%E7%9C%8C!5e0!3m2!1sja!2sjp!4v1710000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <p className="font-sans-jp text-xs text-brown-light mt-3 leading-loose">
              <i className="ri-map-pin-2-line mr-1 text-teal-deep" />
              {restaurantInfo.address}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccessSection;
